/* Chic Home Deco — Chat Questionnaire v4.1 (trust line, instant lower-48 answer, ZIP + order hints) */

(function () {
  'use strict';

  const DATA           = window.CHD_CHAT || {};
  const IS_PRODUCT     = DATA.isProduct || false;
  const PRODUCT_TITLE  = DATA.productTitle || '';
  const PRODUCT_TYPE   = DATA.productType || '';
  const PRODUCT_VENDOR = DATA.productVendor || '';
  const PRODUCT_PRICE  = DATA.productPrice || '';


  /* ── Multi-step questionnaire flow ─────────────────────── */
  const LEVEL1_PRODUCT = [
    'About this product',
    'Shipping & delivery',
    'My order',
    'Something else'
  ];

  const LEVEL1_GENERAL = [
    'About a product',
    'Shipping & delivery',
    'My order',
    'Something else'
  ];

  const FLOW = {
    'About this product': {
      question: "What would you like to know about it?",
      options: [
        'Dimensions & specifications',
        'How it works & fuel type',
        'Installation & setup',
        "I'd like to buy more than one",
        'Something else'
      ]
    },
    'About a product': {
      question: "What would you like to know?",
      options: [
        'Dimensions & specifications',
        'How it works & fuel type',
        'Installation & setup',
        "I'd like to buy more than one",
        'Something else'
      ]
    },
    'Shipping & delivery': {
      question: "What's your shipping question?",
      options: [
        'How long does delivery take?',
        "What's the shipping cost?",
        'Do you ship to my state?',
        'White glove or freight delivery',
        'Something else'
      ]
    },
    'My order': {
      question: "What's happening with your order?",
      options: [
        'Where is my order?',
        'Something else about my order'
      ]
    },
    'Something else': null
  };

  const INSTANT_ANSWERS = {
    'Do you ship to my state?':
      "We deliver to all 48 contiguous US states (the lower 48). We don't ship to Alaska, Hawaii or outside the US."
  };

  /* Short form intro that follows an instant answer (visible even when the message list is squeezed) */
  const INSTANT_INTRO = {
    'Do you ship to my state?': "Lower 48 only — add your ZIP code and we'll confirm the delivery options for your address:"
  };

  /* ── State ──────────────────────────────────────────────── */
  let isOpen            = false;
  let autoTriggered     = false;
  let selectedCategory  = null;
  let selectedSub       = null;
  let submitted         = false;

  /* ── DOM refs ───────────────────────────────────────────── */
  const $ = id => document.getElementById(id);

  const wrap         = $('chd-chat');
  const bubbleBtn    = $('chd-bubble');
  const panel        = $('chd-panel');
  const tooltipEl    = $('chd-tooltip');
  const tooltipText  = $('chd-tooltip-text');
  const tooltipClose = $('chd-tooltip-close');
  const badge        = $('chd-badge');
  const messages     = $('chd-messages');
  const quickReplies = $('chd-quick-replies');
  const closeBtn     = $('chd-close');
  const inputArea    = panel ? panel.querySelector('.chd-input-area') : null;
  const contactForm  = $('chd-contact-form');
  const formName     = $('chd-form-name');
  const formEmail    = $('chd-form-email');
  const formNote     = $('chd-form-note');
  const formPhone    = $('chd-form-phone');
  const formZip      = $('chd-form-zip');
  const NOTE_PLACEHOLDER = formNote ? formNote.placeholder : '';
  const formIntro    = $('chd-form-intro');
  const INTRO_DEFAULT = formIntro ? formIntro.textContent : '';
  const formSubmit   = $('chd-form-submit');
  const formBack     = $('chd-form-back');

  /* ── Helpers ────────────────────────────────────────────── */
  function now() {
    return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  function shortTitle(title, maxWords) {
    const words = title.trim().split(/\s+/);
    if (words.length <= maxWords) return title;
    return words.slice(0, maxWords).join(' ') + '…';
  }

  function addMessage(text, role) {
    const div = document.createElement('div');
    div.className = `chd-msg chd-msg--${role}`;
    const b = document.createElement('div');
    b.className = 'chd-msg__bubble';
    b.textContent = text;
    const t = document.createElement('div');
    t.className = 'chd-msg__time';
    t.textContent = now();
    div.appendChild(b);
    div.appendChild(t);
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }

  function showChips(chips, onClickFn, onBack) {
    quickReplies.innerHTML = '';
    if (onBack) {
      const back = document.createElement('button');
      back.className = 'chd-back chd-back--chips';
      back.textContent = '← Back';
      back.addEventListener('click', onBack);
      quickReplies.appendChild(back);
    }
    chips.forEach(label => {
      const btn = document.createElement('button');
      btn.className = 'chd-chip';
      btn.textContent = label;
      btn.addEventListener('click', () => onClickFn(label));
      quickReplies.appendChild(btn);
    });
    quickReplies.classList.remove('chd-hidden');
    messages.scrollTop = messages.scrollHeight;
  }

  function clearChips() {
    quickReplies.classList.add('chd-hidden');
    quickReplies.innerHTML = '';
  }

  function tailorForm() {
    const shipping = selectedCategory === 'Shipping & delivery';
    const order    = selectedCategory === 'My order';
    if (formZip) formZip.classList.toggle('chd-hidden', !shipping);
    if (formIntro) formIntro.textContent = INSTANT_INTRO[selectedSub] || INTRO_DEFAULT;
    if (formNote) formNote.placeholder = order
      ? 'Order number (e.g. #1234) and your question'
      : NOTE_PLACEHOLDER;
  }

  function showContactForm() {
    tailorForm();
    contactForm.classList.remove('chd-hidden');
    if (inputArea) inputArea.classList.add('chd-hidden');
    setTimeout(() => {
      messages.scrollTop = messages.scrollHeight;
      if (formName) formName.focus();
    }, 80);
  }

  /* ── Step 1: Category ──────────────────────────────────── */
  function startFlow() {
    messages.innerHTML = '';
    selectedCategory = null;
    selectedSub      = null;
    submitted        = false;
    contactForm.classList.add('chd-hidden');
    if (inputArea) inputArea.classList.add('chd-hidden');

    const productPart = IS_PRODUCT && PRODUCT_TITLE
      ? `a question about the ${PRODUCT_TITLE}`
      : 'a question';

    addMessage(
      `Hi there! Have ${productPart}? Pick the topic that fits best and we'll get you the right answer:`,
      'bot'
    );
    const level1 = IS_PRODUCT ? LEVEL1_PRODUCT : LEVEL1_GENERAL;
    setTimeout(() => showChips(level1, onCategoryClick), 200);
  }

  /* ── Step 2: Sub-category ──────────────────────────────── */
  function onCategoryClick(category) {
    selectedCategory = category;
    clearChips();
    addMessage(category, 'user');

    const sub = FLOW[category];

    if (!sub) {
      // "Something else" → skip to form
      setTimeout(() => {
        addMessage(
          "No problem at all! Leave your details below and our team will reach out to you shortly:",
          'bot'
        );
        setTimeout(showContactForm, 350);
      }, 300);
      return;
    }

    setTimeout(() => {
      addMessage(sub.question, 'bot');
      setTimeout(() => showChips(sub.options, onSubClick, () => startFlow()), 200);
    }, 300);
  }

  /* ── Step 3: Form ──────────────────────────────────────── */

  function onSubClick(sub) {
    selectedSub = sub;
    clearChips();
    addMessage(sub, 'user');

    if (INSTANT_ANSWERS[sub]) {
      setTimeout(() => {
        addMessage(INSTANT_ANSWERS[sub], 'bot');
        setTimeout(showContactForm, 350);
      }, 300);
      return;
    }

    setTimeout(() => {
      addMessage(
        "Our specialists have the answer. Leave your details below and we'll reach out to you shortly:",
        'bot'
      );
      setTimeout(showContactForm, 350);
    }, 300);
  }

  /* ── Form logic ────────────────────────────────────────── */
  if (formBack) {
    formBack.addEventListener('click', () => {
      contactForm.classList.add('chd-hidden');
      startFlow();
    });
  }

  if (formName)  formName.addEventListener('input',  () => formName.classList.remove('chd-error'));
  if (formEmail) formEmail.addEventListener('input', () => formEmail.classList.remove('chd-error'));

  if (formName) {
    formName.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); if (formEmail) formEmail.focus(); }
    });
  }
  if (formEmail) {
    formEmail.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); if (formNote) formNote.focus(); }
    });
  }

  const CHD_SESSION_KEY = 'chd_pending_v1';

  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      const name  = formName  ? formName.value.trim()  : '';
      const email = formEmail ? formEmail.value.trim() : '';
      const note  = formNote  ? formNote.value.trim()  : '';
      const phone = formPhone ? formPhone.value.trim() : '';
      const zip   = formZip && !formZip.classList.contains('chd-hidden') ? formZip.value.trim() : '';

      let valid = true;
      if (!name)                                            { if (formName)  formName.classList.add('chd-error');  valid = false; }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (formEmail) formEmail.classList.add('chd-error'); valid = false; }
      if (!valid) { e.preventDefault(); return; }

      const body = buildEmail(name, email, phone, note, zip);

      const hSubject  = $('chd-h-subject');
      const hType     = $('chd-h-type');
      const hProduct  = $('chd-h-product');
      const hUrl      = $('chd-h-url');
      const hPtype    = $('chd-h-ptype');
      const hVendor   = $('chd-h-vendor');
      const hPrice    = $('chd-h-price');
      const hTopic    = $('chd-h-topic');
      const hQuestion = $('chd-h-question');
      const hPhone    = $('chd-h-phone');

      if (hSubject)  hSubject.value  = 'Chat inquiry — ' + (PRODUCT_TITLE || 'Chic Home Deco');
      if (hType)     hType.value     = 'Chat inquiry';
      if (hProduct)  hProduct.value  = PRODUCT_TITLE  || '';
      if (hUrl)      hUrl.value      = window.location.href;
      if (hPtype)    hPtype.value    = PRODUCT_TYPE   || '';
      if (hVendor)   hVendor.value   = PRODUCT_VENDOR || '';
      if (hPrice)    hPrice.value    = PRODUCT_PRICE  ? '$' + PRODUCT_PRICE : '';
      if (hTopic)    hTopic.value    = selectedCategory || '';
      if (hQuestion) hQuestion.value = selectedSub      || '';
      if (hPhone)    hPhone.value    = phone || '';
      const hZip = $('chd-h-zip');
      if (hZip)      hZip.value      = zip || '';

      if (formNote) formNote.value = body;

      try { sessionStorage.setItem(CHD_SESSION_KEY, JSON.stringify({ name, email })); } catch (_) {}

      if (formSubmit) { formSubmit.disabled = true; formSubmit.textContent = 'Sending…'; }
    });
  }

  function addDoneButton() {
    const div = document.createElement('div');
    div.className = 'chd-msg chd-msg--bot';
    const btn = document.createElement('button');
    btn.className = 'chd-done-btn';
    btn.textContent = 'Continue shopping →';
    btn.addEventListener('click', closePanel);
    div.appendChild(btn);
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }

  function buildEmail(name, email, phone, note, zip) {
    const lines = [
      '━━━ New Inquiry — Chic Home Deco ━━━',
      ''
    ];
    if (PRODUCT_TITLE) {
      const productLine = [PRODUCT_TITLE, PRODUCT_TYPE, PRODUCT_VENDOR && `by ${PRODUCT_VENDOR}`, PRODUCT_PRICE && `$${PRODUCT_PRICE}`]
        .filter(Boolean).join(' · ');
      lines.push(`Product  : ${productLine}`);
    }
    lines.push(`Page     : ${window.location.href}`);
    lines.push(`Date     : ${new Date().toLocaleString('en-US', { dateStyle: 'long', timeStyle: 'short' })}`);
    lines.push('');
    lines.push(`Topic    : ${selectedCategory || '—'}`);
    if (selectedSub) lines.push(`Question : ${selectedSub}`);
    if (note) {
      lines.push('');
      lines.push('Message  :');
      lines.push(note);
    }
    lines.push('');
    lines.push('━━━ Contact ━━━');
    lines.push(`Name     : ${name}`);
    lines.push(`Email    : ${email}`);
    lines.push(`Phone    : ${phone || 'Not provided'}`);
    if (zip) lines.push(`ZIP      : ${zip}`);
    lines.push('');
    lines.push('— Submitted via the Chic Home Deco chat widget');
    return lines.join('\n');
  }

  /* ── Open / close ───────────────────────────────────────── */
  function openPanel() {
    isOpen = true;
    sessionStorage.setItem(TOOLTIP_KEY, '1'); /* never show tooltip again once panel opened */
    panel.classList.remove('chd-hidden');
    wrap.classList.add('is-open');
    bubbleBtn.setAttribute('aria-expanded', 'true');
    hideTooltip();
    badge.classList.add('chd-hidden');
    document.body.classList.add('chd-open');
    if (messages.childElementCount === 0) startFlow();
    setTimeout(() => { messages.scrollTop = messages.scrollHeight; }, 80);
  }

  function closePanel() {
    isOpen = false;
    panel.classList.add('chd-hidden');
    wrap.classList.remove('is-open');
    bubbleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('chd-open');
  }

  function showTooltip(text) {
    tooltipText.textContent = text;
    tooltipEl.classList.remove('chd-hidden');
  }

  function hideTooltip() {
    tooltipEl.classList.add('chd-hidden');
  }

  /* ── Tooltip auto-trigger disabled ─────────────────────── */
  const TOOLTIP_KEY = 'chd_tooltip_v4';

  /* ── Sticky ATC co-existence ────────────────────────────── */
  function syncStickyATC() {
    const atc = document.querySelector('.sticky-atc');
    const h = (atc && atc.classList.contains('is-visible')) ? atc.offsetHeight : 0;
    document.documentElement.style.setProperty('--chd-atc-h', h + 'px');
  }

  (function initStickyObserver() {
    const atc = document.querySelector('.sticky-atc');
    if (!atc) return;
    new MutationObserver(syncStickyATC).observe(atc, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', syncStickyATC, { passive: true });
    window.addEventListener('resize', syncStickyATC, { passive: true });
    syncStickyATC();
  })();

  /* ── Event listeners ────────────────────────────────────── */
  bubbleBtn.addEventListener('click', () => isOpen ? closePanel() : openPanel());
  closeBtn.addEventListener('click', closePanel);

  /* Prevent ANY click inside the panel from reaching the document
     close-on-outside-click handler — fixes chip-click closing the panel */
  panel.addEventListener('click', e => e.stopPropagation());

  tooltipClose.addEventListener('click', e => {
    e.stopPropagation();
    hideTooltip();
    sessionStorage.setItem(TOOLTIP_KEY, '1');
  });

  tooltipEl.addEventListener('click', () => {
    hideTooltip();
    openPanel();
  });

  document.addEventListener('click', e => {
    if (isOpen && !bubbleBtn.contains(e.target)) closePanel();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen) closePanel();
  });

  /* ── Post-submit restore (after page reload via native form) ── */
  if (window._chdPostedSuccessfully) {
    const saved = sessionStorage.getItem(CHD_SESSION_KEY);
    if (saved) {
      try {
        const { name, email } = JSON.parse(saved);
        sessionStorage.removeItem(CHD_SESSION_KEY);
        const firstName = name.split(' ')[0];
        addMessage(
          `You're all set, ${firstName}! Our team will reach out to you at ${email} within a few hours.`,
          'bot'
        );
        addDoneButton();
        submitted = true;
        openPanel();
      } catch (_) {}
    }
  }

})();
